import { array, ord, string } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { Payout, PayoutSummary, SimpleAmount, TimeFilterInterval } from '@mews-commander/data-access';
import { LocalizedCurrencyValue } from '@mews/framework';
import { Dash } from '@mews-commander/ui';
import { getUrlParameter } from '@mews-commander/utils';

export const getPayoutsTableData = (payouts: Payout[]) =>
    pipe(
        payouts,
        array.sortBy([
            pipe(
                ord.reverse(string.Ord),
                ord.contramap(({ createdUtc }: Payout) => createdUtc)
            ),
        ])
    );

export const getUrlFilters = () => {
    const startUtc = getUrlParameter('startUtc');
    const endUtc = getUrlParameter('endUtc');

    return startUtc && endUtc ? ({ startUtc, endUtc } as TimeFilterInterval) : {};
};

export const getLocalizedCurrencyValue = (amount?: SimpleAmount | null) =>
    amount ? <LocalizedCurrencyValue value={{ value: amount.value, currency: amount.currencyCode }} /> : <Dash />;

export const hasPayoutSummaryMultipleStateAmounts = (payoutSummaries: PayoutSummary[]) =>
    payoutSummaries.some(({ stateAmounts }) => stateAmounts.length > 1);
